import { GET } from 'utils/requests.utils'

const BASE_URL = '/shop/embeddable_items'

export const fetchItem = (id, data) => GET(`${BASE_URL}/${id}`, data)

export default fetchItem
